import request from "@/utils/request";

export const redeemPromoCode = (data, options = {}) => {
  return request({
    method: "post",
    url: "/promotions/redeem",
    data,
    ...options,
  });
};

export const getReferralDetail = (data, options = {}) => {
  return request({
    method: "post",
    url: "/referrals",
    data,
    ...options,
  });
};

export const getReferralLogs = (data, options = {}) => {
  return request({
    method: "post",
    url: "/referrals/logs",
    data,
    ...options,
  });
};

export const getReferralWithdrawLogs = (data, options = {}) => {
  return request({
    method: "post",
    url: "/referrals/withdraw/logs",
    data,
    ...options,
  });
};
